// src/api/authApi.js
import axios from "axios";
import axiosInstance from "../api/axiosInstance";
import { getClientIp } from "../utils/clientIp";

const API_URL = process.env.REACT_APP_API_URL;

export const loginUser = async (credentials) => {
  try {
    const clientIp = await getClientIp();
    const payload = clientIp
      ? { ...credentials, ipAddress: clientIp }
      : credentials;
    const response = await axios.post(
      `${API_URL}/auth/signin`,
      payload,
      {
        withCredentials: true,
        headers: clientIp ? { "X-Client-IP": clientIp } : undefined,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error logging in:", error.response?.data || error);
    throw error;
  }
};

export const signUpUser = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/auth/signup`, data);
    return response.data;
  } catch (error) {
    console.error("Error signing up:", error.response?.data || error);
    throw error;
  }
};

export const signUpTenant = async (data) => {
  const response = await axios.post(`${API_URL}/tenants/public-signup`, data);
  return response.data;
};

export const getIndustries = async () => {
  const response = await axios.get(`${API_URL}/industry/list`);
  return response.data;
};

export const sendConfirmationCode = async (data) => {
  const response = await axios.post(`${API_URL}/confirmation/send`, {
    ...data,
    channel: "sms",
  });
  return response.data;
};

export const startSignup = async (data) => {
  const response = await axios.post(`${API_URL}/confirmation/start-signup`, {
    ...data,
    channel: "sms",
  });
  return response.data;
};

export const verifyConfirmationCode = async (data) => {
  const response = await axios.post(`${API_URL}/confirmation/verify`, {
    ...data,
    channel: "sms",
  });
  return response.data;
};

export const requestPasswordReset = async (data) => {
  const response = await axios.post(`${API_URL}/password-reset/request`, data);
  return response.data;
};

export const resetPassword = async (data) => {
  const response = await axios.post(`${API_URL}/password-reset/reset`, data);
  return response.data;
};

// Retrieve the current user's profile
export const getUserProfile = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/user-profile`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user profile:", error.response?.data || error);
    throw error;
  }
};

// Update the current user's profile
export const updateUserProfile = async (profileData) => {
  try {
    const response = await axiosInstance.put(
      `${API_URL}/user-profile`,
      profileData,
    );
    return response.data;
  } catch (error) {
    console.error("Error updating user profile:", error.response?.data || error);
    throw error;
  }
};

export const logoutUser = async () => {
  try {
    await axios.post(
      `${API_URL}/auth/logout`,
      {},
      { withCredentials: true },
    );
  } catch (error) {
    console.error("Error logging out:", error.response?.data || error);
  }
};
